export class FrequencyFinder {

    private url: URL;
    private input: HTMLInputElement;
    private searchButton: HTMLElement
    private mapClicks: NodeListOf<HTMLElement>;
    private result: HTMLElement;
    private overlay: HTMLElement;

    constructor(private readonly finder: HTMLElement) {
        this.resolveElements();
        this.addEventListeners();
        console.log("Added")
    }

    private resolveElements() {
        this.url = new URL(this.finder.querySelector<HTMLElement>('[data-frequency-finder-url]').dataset.frequencyFinderUrl);
        this.url.searchParams.delete('cHash');

        this.input = this.finder.querySelector<HTMLInputElement>('[data-frequency-finder-input]');

        this.searchButton = this.finder.querySelector<HTMLElement>('[data-frequency-finder-submit]');

        this.mapClicks = this.finder.querySelectorAll<HTMLElement>('[data-frequency-finder-map-click]');

        this.result = this.finder.querySelector<HTMLElement>('[data-frequency-finder-result]');

        this.overlay = this.finder.querySelector<HTMLElement>('[data-frequency-overlay]');
    }

    private addEventListeners() {
        this.input.addEventListener('keypress', (event) => {
            if (event.key === "Enter") {
                this.submitSearch.call(this, this.input.value);
            }
        });

        this.searchButton.addEventListener('click', () => {
            this.submitSearch.call(this, this.input.value);
        });

        this.mapClicks.forEach(area => {
            area.addEventListener('click', () => {
                this.input.value = area.dataset.frequencyFinderMapClick ?? '';
                this.submitSearch.call(this, area.dataset.frequencyFinderMapClick);
            })
        });
    }

    protected async submitSearch(search: string) {
        this.overlay.classList.add("c-frequency__overlay--active");
        this.input.blur();

        this.url.searchParams.set('tx_ffnfrequency_finder[search]', search)

        const response = await fetch(this.url.toString());

        const html = new DOMParser().parseFromString(await response.text(), "text/html");

        this.result.innerHTML = html.querySelector('[data-frequency-finder-result]').innerHTML;

        this.overlay.classList.remove("c-frequency__overlay--active");

        this.result.scrollIntoView({
            behavior: 'smooth',
            block: 'center',
            inline: 'nearest'
        });

        window.history.replaceState(document, null, this.url.toString());
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll<HTMLElement>('[data-frequency-finder]').forEach(finder => {
        new FrequencyFinder(finder);
    })
});
